window.CKEDITOR_TRANSLATIONS ??= {}

window.CKEDITOR_TRANSLATIONS.ru ??= {
  getPluralForm: (n: number) => n,
  dictionary: {}
}
window.CKEDITOR_TRANSLATIONS.ru.dictionary ??= {}
window.CKEDITOR_TRANSLATIONS.ru.dictionary['Insert file'] = 'Вставить файл'
window.CKEDITOR_TRANSLATIONS.ru.dictionary.Paragraph = 'Текст'
window.CKEDITOR_TRANSLATIONS.ru.dictionary['Heading 1'] = 'H1'
window.CKEDITOR_TRANSLATIONS.ru.dictionary['Heading 2'] = 'H2'
window.CKEDITOR_TRANSLATIONS.ru.dictionary['Heading 3'] = 'H3'

window.CKEDITOR_TRANSLATIONS.en ??= {
  getPluralForm: (n: number) => n,
  dictionary: {}
}
window.CKEDITOR_TRANSLATIONS.en.dictionary ??= {}
window.CKEDITOR_TRANSLATIONS.en.dictionary.Paragraph = 'Text'
